import ReactDOM from 'react-dom';
import React from 'react';
import Streamlined from './themes/streamlined/streamlined';
import GoogleAnalytics from "./analytics/google";
// import AnalyticsManager from './functions/analytics';
import StoreLocator from './utility_components/StoreLocator';

/**
 * Always keep window.recurveRelativeURI set for any component or vanilla JS to call
 * Components will also have a this.relativeURI() utility call
 */
window.relativeURI = function () {
    const storePath = window.session.store.url_path || window.session.store.urlslug;
    return `${document.location.protocol}//${window.session.store.fqdn}/${storePath}`;
}

document.addEventListener('DOMContentLoaded', () => {
    //TODO: Remove hardcoded value
    const theme = 'streamlined';
    if (document.location.pathname.includes('/locator')) { //Locator Page for chain
        ReactDOM.render(<StoreLocator />, document.getElementById('storeLocator'));
    }else {

        if(theme === 'streamlined') {
            Streamlined();
        }

        // AnalyticsManager.initialize();
        GoogleAnalytics.start();
        GoogleAnalytics.recordPageView();
    }
});

